import React from 'react'

export default function InventoryStyle({signed_in}) {
  let report_buttons = null
  if (signed_in !== 'admin') {
    report_buttons = {
      products_inventory_display: (signed_in.user_access.reports_inventory_reports_products_inventory) ? 'flex' : 'none',
      out_of_stocks_display: (signed_in.user_access.reports_inventory_reports_out_of_stocks) ? 'flex' : 'none',
      price_list_display: (signed_in.user_access.reports_inventory_reports_price_list) ? 'flex' : 'none',
      products_sold_display: (signed_in.user_access.reports_inventory_reports_products_sold) ? 'flex' : 'none',
      unmoving_products_display: (signed_in.user_access.reports_inventory_reports_unmoving_products) ? 'flex' : 'none',
      products_with_expirations_display: (signed_in.user_access.reports_inventory_reports_products_with_expirations) ? 'flex' : 'none'
    }
  } else {
    report_buttons = {
      products_inventory_display: 'flex',
      out_of_stock_display: 'flex',
      products_sold_display: 'flex',
      unmoving_products_display: 'flex',
      price_list_display: 'flex',
      products_with_expirations_display: 'flex'
    }
  }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        :root { --light: #555; }

        .report-item-container {
          /*background-color: blue;*/
          display: flex;
          flex-direction: column;
          font-size: 1rem;
          padding: 10px;
        }

        .report-item-header {
          display: flex;
          background-color: lightgreen;
          padding: 10px;
          margin: auto;
          margin-left: 0;
          font-size: 1rem;
          box-sizing: border-box;
          justify-content: stretch;
          width: 100%;
          border: none;
        }
        .report-item-header:hover {
          background-color: rgb(95, 240, 59);
          cursor: pointer;
        }

        .report-items-container {
          border: solid 1px lightgreen;
          border-top: none;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
          overflow: auto;
          padding: 30px 30px;
        }

        .hide-ric { display: none; }

        .report-item-wrapper {
          border: none;
          background-color: lightskyblue;
          display: flex;
          flex-direction: column;
          margin: 10px;
        }
        .report-item-title, .report-item-description {
          padding: 10px;
          text-align: left;
        }
        .report-item-title { font-size: 1.2rem; }
        .report-item-description {
          font-size: 0.95rem;
          color: var(--light, #555);
        }

        .report-item-wrapper:hover, .report-item-wrapper:focus {
          /* let's change the ---light here so settings-item-description is also affected by hover */
          transform: scale(1.0003);
          box-shadow: 1px 1px 2px 1px #BBB;
          border: none;
          background-color: blue;
          color: white;
          outline: none;
          --light: white;
        }

        /** Reports Buttons **/
        #products-inventory-btn { display: ${report_buttons.products_inventory_display}; }
        #out-of-stocks-btn { display: ${report_buttons.out_of_stocks_display}; }
        #price-list-btn { display: ${report_buttons.price_list_display}; }
        #products-sold-btn { display: ${report_buttons.products_sold_display}; }
        #unmoving-products-btn { display: ${report_buttons.unmoving_products_display}; }
        #products-with-expirations-btn { display: ${report_buttons.products_with_expirations_display}; }

      `}
      </style>
    </React.Fragment>
  )
}
